import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/@babel/runtime/regenerator/index.js";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import i18next from "i18next";
var GalleryComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.PDGalleryPage;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var GalleryPage = function GalleryPage() {
  var _store$common, _store$common2;
  var store = useStore();
  var conceptCode = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 || (_store$common = _store$common.concept) === null || _store$common === void 0 ? void 0 : _store$common.conceptCode;
  var conceptCodeDesc = store === null || store === void 0 || (_store$common2 = store.common) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.appAttributes) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.concept) === null || _store$common2 === void 0 ? void 0 : _store$common2.conceptCodeDesc;
  var router = useRouter();
  useEffect(function () {
    // Load jQuery and Bootstrap sequentially before common.js is injected by PageWrapper,
    // preventing a race condition where common.js executes before its dependencies are available.
    var loadScript = function loadScript(src) {
      return new Promise(function (resolve) {
        if (document.querySelector("script[src=\"".concat(src, "\"]"))) {
          resolve();
          return;
        }
        var script = document.createElement("script");
        script.src = src;
        script.onload = function () {
          return resolve();
        };
        document.head.appendChild(script);
      });
    };
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadScript("https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js");
          case 2:
            _context.next = 4;
            return loadScript("https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js");
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
    store === null || store === void 0 || store.initComponent("PrivateDining").then(function () {
      //
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("text.private_dining.page.gallery.title", {
    defaultValue: "Gallery | Private Dining | ".concat(conceptCodeDesc, " Restaurant")
  })), __jsx("meta", {
    name: "description",
    content: i18next.t("text.private_dining.page.gallery.metadescription", {
      defaultValue: "Experience a virtual walkthrough via our photo gallery slide show of the private dining rooms available at ".concat(conceptCodeDesc, " Restaurant. Learn more today.")
    })
  }), __jsx("link", {
    rel: "stylesheet",
    href: "/pd/common/common.css"
  }), conceptCode ? __jsx("link", {
    rel: "stylesheet",
    href: "/pd/css/".concat(conceptCode === null || conceptCode === void 0 ? void 0 : conceptCode.toLocaleLowerCase(), "_PD.css")
  }) : null), __jsx(GalleryComp, {
    route: router === null || router === void 0 ? void 0 : router.asPath
  }));
};
GalleryPage.layout = PageLayout.NB_LAYOUT;
GalleryPage.layoutProps = {
  analyticsData: {
    pageName: "private-dining gallery",
    pageType: "private-dining"
  }
};
export default observer(GalleryPage);